import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { OnboardingStep } from '@repo/shared/dtos/organization'

import { AsyncThunkConfig, RejectValue } from '@/store/actions'
import { createFakeAsyncThunk } from '@/store/helpers'
import { OrganizationCreationFields } from '@/store/spi/api'
import { GenerationPayload } from '@/store/thunks/assistant'
import { CaseWorker, Organization } from '@/store/user'

export const onboarding = {
  admin: {
    init: createFakeAsyncThunk<GenerationPayload>('ONBOARDING_INIT'),

    setNextStep: createAsyncThunk<
      { organization: Organization },
      { step: OnboardingStep },
      AsyncThunkConfig
    >(
      'ONBOARDING_SET_NEXT_STEP',
      async ({ step }, { extra: { api }, rejectWithValue, getState, fulfillWithValue }) => {
        const organizationId = getState().user.currentOrganizationId
        if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)
        const res = await api.admin.organizations.patchOne({
          organizationId,
          fields: {
            onboarding: {
              step,
            },
          },
        })
        if (hasError(res)) return rejectWithValue(handleError(res))
        return fulfillWithValue({ organization: res })
      },
    ),

    createOrganization: createAsyncThunk<
      { caseWorker: CaseWorker; organization: Organization },
      OrganizationCreationFields,
      AsyncThunkConfig
    >(
      'ONBOARDING_CREATE_ORGANIZATION',
      async (p, { extra: { api }, rejectWithValue, fulfillWithValue }) => {
        const res = await api.admin.organizations.createOneFromAssistant(p)
        if (hasError(res)) return rejectWithValue(handleError(res))
        return fulfillWithValue(res)
      },
    ),
  },
}
